import * as actionTypes from "./ReconcileTypes";

const INITIAL_STATE = {
    customerList: [],
    branchList: [],
    resetDoc: [],
    advanceList: [],
    settlementListInApproval: [],
    attachments: [],
    approvalStatus: [],
    settlementListHeaderFilterData: [],
    settlementHeaderFilterData: []
};

const ReconcileReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETCUSTOMERLIST:
            return {
                ...state,
                customerLists: action.payload.list,
            };
        case actionTypes.SETBRANCHLIST:
            return {
                ...state,
                branchLists: action.payload.list,
            };
        case actionTypes.SETADVANCELIST:
            return {
                ...state,
                advanceList: action.payload.list,
            };
        case actionTypes.SETRESETDOC:
            return {
                customerList: [],
                branchList: [],
                advanceList: [],
                attachments: [],
                approvalStatus: []
            };
        case actionTypes.SETSETTLEMENTLISTINAPPROVAL:
            return {
                ...state,
                settlementListInApproval: action.payload.list
            };
        case actionTypes.SETSETTLEMENTATTACHMENTS:
            return {
                ...state,
                attachments: action.payload.list
            };
        case actionTypes.SETAPPROVALSTATUS:
            return {
                ...state,
                approvalStatus: action.payload.list
            };
        case actionTypes.SETSETTLEMENTLISTBASICFILTERDATA:
            return {
                ...state,
                settlementListHeaderFilterData: { ...action.payload }
            };
        case actionTypes.SETSETTLEMENTBASICFILTERDATA:
            return {
                ...state,
                settlementHeaderFilterData: { ...action.payload }
            };
        default:
            return state;
    }
}

export default ReconcileReducer;